import React, { useEffect, useState } from "react";
import ObservationList from "./observationList";
import * as observationAction from "../../../redux/actions/observationAction";
import { useDispatch, useSelector } from "react-redux";
import {
  VIEW_OBSERVATION_DETAILS,
  OBSERVATION,
  ACCESS_DENIED,
} from "../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import { API_STATUS, GRID_DEFAULT_PAGE_SIZE } from "../../../constant/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { toast, ToastContainer } from "react-toastify";
import { InactiveClient, getUserBaseDivisionInfo } from "../../../utils/helper";

const ObservationListContainer = () => {
  const disptch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector(
    (state) =>
      state.observationList?.isLoading || state.deleteObservation?.isLoading
  );
  const observationList = useSelector((state) => state.observationList);
  const deleteObservation = useSelector((state) => state.deleteObservation);
  const [sendEmail, setSendEmail] = useState(false);
  const { hasBaseDivisionAdminAccess, baseDivisionIds } =
    getUserBaseDivisionInfo();

  const getObservationListData = (data) => {
    const payload = {
      ...data,
      divisionId: hasBaseDivisionAdminAccess
        ? baseDivisionIds
        : (data?.divisionId ?? 0),
    };
    if (payload?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
      disptch(observationAction.getObservationsFilterObj(payload));
    }
    disptch(observationAction.getListOfObservationPending(payload));
  };

  const handleViewOnClick = (
    insObservationId,
    observedType,
    observedEmployee,
    status
  ) => {
    sessionStorage.setItem("observationListPreserveState", "true");
    navigate(VIEW_OBSERVATION_DETAILS, {
      state: {
        insObservationId: insObservationId,
        observedType: observedType,
        observedEmployee: observedEmployee,
        status:status,
      },
    });
  };

  const addObservation = () => {
    if (InactiveClient()) return;
    navigate(OBSERVATION);
  };
  useEffect(() => {
    if (observationList?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Observation has been sent to registered email ID");
    }
  }, [observationList]);

  const handleDeleteOnClick = (data) => {
    disptch(observationAction.deleteObservationPending(data));
  };

  useEffect(() => {
    if (deleteObservation?.status === API_STATUS.SUCCESS) {
      const data = {
        pageSize: GRID_DEFAULT_PAGE_SIZE,
        ...observationList?.filterObj,
        page: 1,
        // earchText: "",
        // fromdate: "",
        // todate: "",
        // location: "",
        // Status: "",
        // itemTypes: "",
        // isSendMail: false,
      };
      // disptch(observationAction.clearObservation());
      getObservationListData(data);
    }
  }, [deleteObservation]);


  return (
    <>
      {checkPrivileges([12, 84, 85, 86]) ? (
        <>
          {" "}
          <ToastContainer />
          <ObservationList
            observationList={observationList.data?.result}
            getObservationListData={getObservationListData}
            isLoading={isLoading}
            handleViewOnClick={handleViewOnClick}
            addObservation={addObservation}
            handleDeleteOnClick={handleDeleteOnClick}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default ObservationListContainer;
